/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import { Theme } from "@mui/material";

const receiptsUploadStyle = {
  paper: {
    padding: "0rem",
  },
  inlineHintBox: (theme: Theme) => ({
    margin: "0 auto 40px auto",
    maxWidth: "700px",
    textAlign: "left",
    "& h5": {
      color: theme.palette.text.primary,
      marginBottom: "20px",
    },
  }),
  buttonContainer: {
    maxWidth: "350px",
    margin: "0 auto 40px auto",
  },
  divider: {
    borderBottom: "2px solid #ccc",
    margin: "1.5rem 0",
  },
  signatureCaption: {
    textAlign: "center",
  },
  headline: (theme: Theme) => ({
    textAlign: "left",
    fontWeight: "bold",
    color: theme.palette.text.primary,
  }),
};

export default receiptsUploadStyle;
